module.exports = __webpack_public_path__ + "static/media/Calgary_Flames.948080f9.svg";